import { Button } from '@mui/material'
import { FileManagerList } from 'common'
import { TooltipInformation } from 'common'

export const CollateralImagesTable = ({ useFetchInit }) => {
    const { Forms, Actions, globalStates } = useFetchInit

    const { FormCollateral: { formState } } = Forms
    const { formOpeningMode } = globalStates
    const isReadOnly = formOpeningMode === 'READONLY'

    const { handleClickDeleteCollateralImage, handleClickDownloadImage } = Actions

    const cellRendererTooltip = (params) => {
        const { idimagen, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
        return (
            <TooltipInformation
                idregistro={idimagen}
                usuario_creo={usuario_creo}
                fecha_creo={fecha_creo}
                usuario_modifico={usuario_modifico}
                fecha_modifico={fecha_modifico}
            />
        )
    }

    const cellRendererOptions = (params) => {
        const { idimagen, document_originalname, document_path } = params.data

        return (
            <>
                <Button
                    variant='contained'
                    size='small'
                    color='success'
                    onClick={() => handleClickDownloadImage(document_originalname, document_path)}
                    style={{ marginRight: '0.4vh' }}
                >
                    <i className="fa-solid fa-download" style={{ marginRight: '8px' }}></i> Descargar
                </Button>

                {/* Igual que paso 2: Eliminar solo en EDITABLE */}
                {!isReadOnly && (
                    <Button
                        variant='contained'
                        size='small'
                        onClick={() => handleClickDeleteCollateralImage(idimagen)}
                        color='error'
                        style={{ marginRight: '0.4vh' }}
                    >
                        <i className="fa-solid fa-trash" style={{ marginRight: '8px' }}></i> Eliminar
                    </Button>
                )}
            </>
        )
    }

    const columnConfig = [
        {
            headerName: "Info",
            minWidth: 120,
            maxWidth: 120,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: cellRendererTooltip
        },
        { field: "document_originalname", headerName: "NOMBRE DEL ARCHIVO", minWidth: 300, filter: true },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: cellRendererOptions
        },
    ]

    return (
        <div className='content'>
            <FileManagerList
                rowConfig={formState.images}
                columnConfig={columnConfig}
            />
        </div>
    )
}
